export default __webpack_public_path__ + "static/media/dimension.3a9e61fa.svg";